import React from 'react';
import { Alert, Button, Skeleton, Switch, message } from 'antd';
import { fetchRecommendationPreferences, updateRecommendationPreferences } from '@/apis/posts';
import usePrivateList from '@/utils/usePrivateList';
import usePrivateAction from '@/utils/usePrivateAction';
import './index.scss';

const RecommendationPreferences = () => {
  const { data, loading, error, load } = usePrivateList(fetchRecommendationPreferences, {}, '推荐设置加载失败');
  const { busy, run } = usePrivateAction();
  const enabled = Boolean(data?.collaborative_enabled);
  return <section className="featurePage-panel recommendation-preferences" aria-labelledby="recommendation-preferences-heading">
    <div className="recommendation-preferences-heading">
      <div className="recommendation-preferences-title">
        <div><h2 id="recommendation-preferences-heading">综合推荐的数据使用</h2><p>决定是否让你的互动行为参与综合推荐。</p></div>
      </div>
      {!loading && !error && <div className="recommendation-preferences-control">
        <span className={`recommendation-preferences-status${enabled ? ' is-enabled' : ''}`}>{enabled ? '已开启' : '已关闭'}</span>
        <Switch aria-label="允许用于综合推荐" checked={enabled} disabled={busy} loading={busy} onChange={collaborative_enabled => run(() => updateRecommendationPreferences({ collaborative_enabled }), async () => {
          await load().catch(() => {}); message.success(collaborative_enabled ? '已开启综合推荐的数据使用' : '已关闭综合推荐的数据使用');
        })} />
      </div>}
    </div>
    {loading ? <Skeleton active paragraph={{ rows: 2 }} /> : error ? <Alert type="error" showIcon title={error} action={<Button onClick={() => load().catch(() => {})}>重试</Button>} /> : null}
    <div className="recommendation-preferences-details">
      <div><h3>使用哪些数据</h3><p>推荐曝光、点击及报名行为会与已同意参与的用户的汇总行为比较，为综合推荐提供参考。</p></div>
      <div><h3>随时掌控</h3><p>默认关闭，可随时调整。关闭后停止用于新的综合推荐，已有推荐和报名记录保留。</p></div>
      <div><h3>推荐如何排序</h3><p>未开启或数据不足时使用兴趣标签排序。推荐分数不代表活动成功率。</p></div>
    </div>
  </section>;
};
export default RecommendationPreferences;
